module.exports = __webpack_public_path__ + "img/3.77270fc6.png";